module.exports = __webpack_public_path__ + "img/top-border-fishing.75561d45.png";